// https://github.com/pixiv/three-vrm/blob/e4a2dcc7de2e0f5801e91afe9b4150982a0b06c4/packages/three-vrm-core/src/firstPerson/VRMFirstPerson.ts#L11
export const THREE_VRM_DEFAULT_FIRSTPERSON_ONLY_LAYER = 9;
export const DEFAULT_THIRDPERSON_ONLY_LAYER = 10;
